import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../../shared/const/localstorage";
import {
    setResponseSingOffMeeting,
    setResponseSubscribedLessonId
} from "../../../../slice/lessons/lessons-demo/setLessonsDemo";


export const singOffMeeting = createAsyncThunk(
    "lessons/singOffMeeting",
    async (lessonsId: number, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const response = await axios.post(`/api/lessons/${lessonsId}/sign-off`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            thunkAPI.dispatch(setResponseSingOffMeeting(response.data))
            thunkAPI.dispatch(setResponseSubscribedLessonId(response.data.subscribedLessonId))

            return response.data;

        } catch (error) {
            console.error("Произошла ошибка:", error);
            return thunkAPI.rejectWithValue("error");
        }
    }
);
